module.exports = __webpack_public_path__ + "img/logo-seara-512.7cee9411.png";